import './IconSuccess.scss';

export const IconSuccess = () => (
    <div className="icon-success">
        <svg width="47" height="47" viewBox="0 0 47 47" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M23.1 0C35.9 0 46.2 10.4 46.2 23.1C46.2 35.8 35.8 46.2 23.1 46.2C10.4 46.2 0 35.8 0 23.1C0 10.4 10.3 0 23.1 0Z"
                fill="#FF8E14"
            />
            <path d="M9.7002 26.1L20.6002 36.4L36.5002 13" fill="#FF8E14" />
            <path
                d="M9.7002 26.1L20.6002 36.4L36.5002 13"
                stroke="white"
                strokeWidth="5"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    </div>
);
